module.exports = __webpack_public_path__ + "static/media/play-captured-stone.0c11aace.png";